import * as React from 'react';

const LogoEColorBrandSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="logo-e-color-brand_svg__eds-icon--logo-e-color-brand_svg"
        viewBox="0 0 120 120"
        {...props}
    >
        <defs>
            <linearGradient
                x1="7.797%"
                y1="95.373%"
                x2="95.085%"
                y2="1.517%"
                id="logo-e-color-brand_svg__linearGradient-1"
            >
                <stop stopColor="#F6682F" offset="0%" />
                <stop stopColor="#FFB91E" offset="100%" />
            </linearGradient>
        </defs>
        <g
            id="logo-e-color-brand_svg__Page-1"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g id="logo-e-color-brand_svg__logo-e-color-brand">
                <circle
                    id="logo-e-color-brand_svg__Oval"
                    fill="url(#logo-e-color-brand_svg__linearGradient-1)"
                    cx={59}
                    cy={59}
                    r={59}
                />
                <path
                    d="M54.384 39.263c8.401-1.862 16.785 1.513 21.453 7.897l-37.131 8.232c1.281-7.703 7.276-14.266 15.678-16.129zm21.66 30.286c-2.807 3.995-7.135 7.018-12.411 8.188-8.457 1.875-16.895-1.559-21.545-8.024l37.246-8.258 6.067-1.345L97 57.538a35.32 35.32 0 00-.966-7.247C91.313 30.654 70.909 18.41 50.46 22.943 30.011 27.477 17.261 47.072 21.982 66.71c4.722 19.637 25.126 31.881 45.574 27.348 12.05-2.672 21.422-10.573 26.125-20.63L76.044 69.55z"
                    id="logo-e-color-brand_svg__Shape"
                    fill="#FFF"
                    fillRule="nonzero"
                />
            </g>
        </g>
    </svg>
);

LogoEColorBrandSvg.displayName = 'LogoEColorBrandSvg';
export default LogoEColorBrandSvg;
